import rootReducer from 'reducers';

import { coreActions } from 'app-components/flux/core-actions';
import store, { immutableSerialize } from 'app-components/utils/redux-store';

export const copyState = (state = store.getState(), sanitize = false) => {
  const stateSanitized = sanitize ? rootReducer(store.getState(), coreActions.sanitize()) : state;
  const json = immutableSerialize.dehydrateImmutable(stateSanitized);
  const blob = new Blob([json], { type: 'application/json' });
  return blob;
};

export const saveStore = (name = 'store.js', sanitize = false) => {
  const state = store.getState();
  const blob = copyState(state, sanitize);
  const fileDownload = document.getElementById('fileDownload') || document.createElement('a');
  fileDownload.id = 'fileDownload';
  fileDownload.style.display = 'none';
  fileDownload.href = URL.createObjectURL(blob);
  fileDownload.download = name;
  fileDownload.click();
};
